import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import AddEditCopyProduct from '../components/addEditCopyProduct.vue';

var EditProductPage = function (_super) {
  __extends(EditProductPage, _super);

  function EditProductPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  EditProductPage = __decorate([Component({
    components: {
      AddEditCopyProduct: AddEditCopyProduct
    }
  })], EditProductPage);
  return EditProductPage;
}(Vue);

export default EditProductPage;